import { render, staticRenderFns } from "./LevyCalculationPanelRiskRatedPremium.vue?vue&type=template&id=fa4fc02c&"
import script from "./LevyCalculationPanelRiskRatedPremium.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelRiskRatedPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports